import { searchPublishersForCatalogTransfer } from '@App/api/routes/search'
import PublicSearchPublishersStore from '@App/stores/search/public/public-search-publishers-store'
import { PaginationBody } from '@Entities/pagination'
import { SearchResultPartyDetails } from '@Entities/party-details'
import { PublisherSearch } from '@App/stores/search/models/publisher-search'
import { InterestedPartyWithWorkCount } from '@Entities/interested-party-with-work-count'

class SourceSearchPublishersStore extends PublicSearchPublishersStore {
    protected async searchForPartiesApiCall(pagination: PaginationBody, query: PublisherSearch) {
        const results = await searchPublishersForCatalogTransfer(pagination, query)
        const publishers = results.data
        return {
            parties: publishers.content.map((publisher) => SourceSearchPublishersStore.opToPartyDetails(publisher)),
            count: publishers.totalElements,
        }
    }

    static opToPartyDetails = (publisher: InterestedPartyWithWorkCount): SearchResultPartyDetails => ({
        ipId: publisher.ipId?.toString(),
        ipiNumber: publisher.ipiNumber,
        worksCount: publisher.worksCount,
        name: publisher.fullName,
        hfaPublisherNumber: publisher.hfaNumber ?? undefined,
    })
}

export default SourceSearchPublishersStore
